import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _followMemberRequest = {};
var _followMemberResponse = {};
var _listMemberConnectionsRequest = {};
var _listMemberConnectionsResponse = {};
var _listMemberFollowersRequest = {};
var _listMemberFollowersResponse = {};
var _listMemberFollowingRequest = {};
var _listMemberFollowingResponse = {};
var _listMyMemberConnectionsRequest = {};
var _listMyMemberConnectionsResponse = {};
var _listMyMemberFollowersRequest = {};
var _listMyMemberFollowersResponse = {};
var _listMyMemberFollowingRequest = {};
var _listMyMemberFollowingResponse = {};
var _unfollowMemberRequest = {};
var _unfollowMemberResponse = {};
function resolveComWixpressMembersFollowV2MemberFollowersServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/members-follow-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/members-follow-server',
                destPath: '/api',
            },
            {
                srcPath: '/_api/members/v2/followers',
                destPath: '/v2/followers',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/members-follow-server',
                destPath: '/api',
            },
            {
                srcPath: '/_api/members/v2/followers',
                destPath: '/v2/followers',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/_api/members-follow-server',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/members-follow-server',
                destPath: '/api',
            },
            {
                srcPath: '/_api/members/v2/followers',
                destPath: '/v2/followers',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v2/followers',
                destPath: '/v2/followers',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Sets the current member to follow another member. */
export function followMember(payload) {
    return function __followMember(_a) {
        var host = _a.host;
        var toJSON = serializer(_followMemberRequest, {}).toJSON;
        var fromJSON = serializer(_followMemberResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressMembersFollowV2MemberFollowersServiceUrl({
                protoPath: '/v2/followers/{memberId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Sets the current member to unfollow another member. */
export function unfollowMember(payload) {
    return function __unfollowMember(_a) {
        var host = _a.host;
        var toJSON = serializer(_unfollowMemberRequest, {}).toJSON;
        var fromJSON = serializer(_unfollowMemberResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveComWixpressMembersFollowV2MemberFollowersServiceUrl({
                protoPath: '/v2/followers/{memberId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Returns IDs of members followed by the member making the call */
export function listMyMemberFollowing(payload) {
    return function __listMyMemberFollowing(_a) {
        var host = _a.host;
        var toJSON = serializer(_listMyMemberFollowingRequest, {}).toJSON;
        var fromJSON = serializer(_listMyMemberFollowingResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveComWixpressMembersFollowV2MemberFollowersServiceUrl({
                protoPath: '/v2/followers/my/following',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Lists members who are followed by the requested member. */
export function listMemberFollowing(payload) {
    return function __listMemberFollowing(_a) {
        var host = _a.host;
        var toJSON = serializer(_listMemberFollowingRequest, {}).toJSON;
        var fromJSON = serializer(_listMemberFollowingResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveComWixpressMembersFollowV2MemberFollowersServiceUrl({
                protoPath: '/v2/followers/{memberId}/following',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Returns IDs of members who follow the member making the call */
export function listMyMemberFollowers(payload) {
    return function __listMyMemberFollowers(_a) {
        var host = _a.host;
        var toJSON = serializer(_listMyMemberFollowersRequest, {}).toJSON;
        var fromJSON = serializer(_listMyMemberFollowersResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveComWixpressMembersFollowV2MemberFollowersServiceUrl({
                protoPath: '/v2/followers/my',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Lists members who follow the requested member. */
export function listMemberFollowers(payload) {
    return function __listMemberFollowers(_a) {
        var host = _a.host;
        var toJSON = serializer(_listMemberFollowersRequest, {}).toJSON;
        var fromJSON = serializer(_listMemberFollowersResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveComWixpressMembersFollowV2MemberFollowersServiceUrl({
                protoPath: '/v2/followers/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Returns information if provided site members are followers or are followed by the member making the call. */
export function listMyMemberConnections(payload) {
    return function __listMyMemberConnections(_a) {
        var host = _a.host;
        var toJSON = serializer(_listMyMemberConnectionsRequest, {}).toJSON;
        var fromJSON = serializer(_listMyMemberConnectionsResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveComWixpressMembersFollowV2MemberFollowersServiceUrl({
                protoPath: '/v2/followers/my/connections',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Lists a member's follower or following connections to the other members specified in the request.
 * > Note: If no other members' IDs (`connectedMemberIds`) are passed, the call will return successful, but with no data.
 */
export function listMemberConnections(payload) {
    return function __listMemberConnections(_a) {
        var host = _a.host;
        var toJSON = serializer(_listMemberConnectionsRequest, {}).toJSON;
        var fromJSON = serializer(_listMemberConnectionsResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveComWixpressMembersFollowV2MemberFollowersServiceUrl({
                protoPath: '/v2/followers/{memberId}/connections',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map